import useAuth from '@/hooks/useAuth';
import UserDropdown from '@/components/Dropdowns/UserDropdown'

export default function Navbar() {
  const { user } = useAuth();

  return (
    <>
      <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center py-4">
        <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          <a
            className="text-white text-sm uppercase lg:inline-block font-semibold"
            href="#"
            onClick={(e) => e.preventDefault()}
          >
            {user.user.companyName}
          </a>
          <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
            <UserDropdown />
          </ul>
        </div>
      </nav>
    </>
  );
}
